module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('menu', [_c('header', {
    class: {
      "semi": _vm.$route.name === "index"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "home-link",
    attrs: {
      "id": "logo"
    },
    on: {
      "click": _vm.toHome
    }
  }, [_vm._v("Jacques Daniel")])]), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [(_vm.main.loaded.index && _vm.$route.name !== "index" && _vm.$route.name !== "single") ? _c('router-link', {
    attrs: {
      "to": "/index",
      "id": "index"
    }
  }, [_vm._v("archive")]) : _vm._e()], 1), _vm._v(" "), (_vm.$route.name === "search" && _vm.main.search.length > 0) ? _c('div', {
    attrs: {
      "id": "search-marker"
    }
  }, [_vm._v("search results (" + _vm._s(_vm.main.search.length) + "): " + _vm._s(_vm.main.searchTerm))]) : (_vm.$route.name === "search" && _vm.main.search.length < 1) ? _c('div', [_vm._v("no results")]) : _vm._e()]), _vm._v(" "), (_vm.$route.name === "index" || _vm.$route.name === "single" || _vm.$route.name === "home") ? _c('div', {
    class: {
      "index": _vm.$route.name === "index"
    },
    attrs: {
      "id": "text-container"
    }
  }, [_c('div', {
    class: {
      "inner": _vm.$route.name === "index"
    }
  }, [(_vm.main.loaded.single) ? _c('div', {
    staticClass: "caption-container"
  }, [(_vm.main.single.acf.extended_caption_check) ? _c('cap', {
    attrs: {
      "content": _vm.main.single.acf.extended_caption,
      "links": _vm.main.single.acf.links
    }
  }) : _c('cap', {
    attrs: {
      "content": _vm.main.single.acf.caption,
      "links": _vm.main.single.acf.links
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.main.loaded.index && _vm.$route.name === "index") ? _c('div', {
    attrs: {
      "id": "index-container"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.main.index.acf.text)
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$route.name === "home" || _vm.$route.name === "collection") ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "text",
      "placeholder": "search"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.main.loaded.text) ? _c('txt') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de09bb9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 478
// module chunks = 2